import 'phaser'
import {
    CST
} from '../CST'

export default class BubblesIntro extends Phaser.Scene {

    constructor() {
        super(CST.SCENES.BUBBLESINTRO);
    }

    create(data) {
        this.clickSound = this.sound.add("click-sound");

        this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'bubble-intro');

        this.menu_btn = this.add.image(125, 835, 'menu-button').setInteractive({
            useHandCursor: true
        }).on('pointerdown', () => {
            this.menu_btn.setTexture('menu-button');
        }).on('pointerup', () => {
            this.clickSound.play();
            this.menu_btn.setTexture('menu-button');
            location.reload();
        })

        this.nextBtn = this.add.image(1385, 835, 'next-button-orange').setDepth(1.5).setInteractive({
            useHandCursor: true
        }).on("pointerdown", () => {
            this.clickSound.play();
            this.scene.start(CST.SCENES.BUBBLES, {
                User_ID: data.User_ID
            });
        });
    }
}